<template>
  <div class="mobile—login">
    <div v-if="type === 1">
      <div class="header">
        <img src="../assets/imgs/logo.png" style="height: 100px" alt="" />
      </div>
      <div class="content">
        <div class="input-box">
          手机号码
          <van-field
            v-model="passwordForm.mobile"
            placeholder="请输入手机号码"
          />
        </div>
        <div class="input-box">
          图形验证码
          <div class="code-box">
            <van-field
              v-model="passwordForm.captcha"
              placeholder="请输入图形验证码"
            />
            <div @click="getCaptchaCode" class="captcha-box">
              <div class="loading-img" v-if="codeLoading"><van-loading /></div>
              <img v-else :src="captchaUrl" />
            </div>
          </div>
        </div>
        <div class="input-box">
          密码
          <van-field
            v-model="passwordForm.password"
            type="password"
            placeholder="请输入密码"
          />
        </div>
      </div>
      <div class="input-box input-box-set">
        <div class="sms-code" @click="handleCutType(2)">使用短信验证码登录</div>
        <div class="set-code" @click="handleCutType(2)">注册报名</div>

      </div>

      <div class="footer">
        <div class="login gradient-background" @click="handlePasswordLogin">
          确定<van-loading v-if="loading" size="16" />
        </div>
      </div>
    </div>

    <div v-if="type === 2">
      <div class="header">
        <img src="../assets/imgs/logo.png" style="height: 100px" alt="" />
      </div>
      <div class="content">
        <div class="input-box">
          手机号码
          <van-field v-model="smsForm.phone" placeholder="请输入手机号码" />
        </div>
        <div class="input-box">
          图形验证码
          <div class="code-box">
            <van-field
              v-model="smsForm.captcha"
              placeholder="请输入图形验证码"
            />
            <div @click="getCaptchaCode" class="captcha-box">
              <div class="loading-img" v-if="codeLoading"><van-loading /></div>

              <img v-else :src="captchaUrl" />
            </div>
          </div>
        </div>
        <div class="input-box">
          短信验证码
          <div class="code-box">
            <van-field
              v-model="smsForm.smsCode"
              placeholder="请输入短信验证码"
              maxlength="6"
            />
            <div
              @click="getSMSCode"
              class="get-code"
              :class="{ disabled: countdown > 0 }"
            >
              {{ countdown > 0 ? `${countdown}s后重新获取` : "获取验证码" }}
            </div>
          </div>
        </div>
      </div>
      <div class="input-box">
        <div class="sms-code" @click="handleCutType(1)">使用密码登录</div>
      </div>
      <!-- <div class="input-box">
      <div class="set" @click="sign()">注册账号</div>
      <div class="reset" @click="reset()">忘记密码</div>
    </div> -->
      <div class="footer">
        <div class="login gradient-background" @click="handleSmsLogin">
          确定<van-loading v-if="loading" size="16" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Loading } from "@element-plus/icons-vue";
export default {
  name: "OfficialLogin",
  components: { Loading },
  data() {
    return {
      passwordForm: { mobile: "", password: "", captcha: "", captchaId: "" },
      smsForm: { phone: "", captcha: "", smsCode: "", captchaId: "" },
      type: 1,
      loading: false,
      countdown: 0,
      timer: null,
      captchaUrl: "",
      codeLoading: false,
    };
  },
  methods: {
    async getCaptchaCode() {
      this.codeLoading = true;
      try {
        // 清理旧的 URL，避免内存泄漏
        if (this.captchaUrl) {
          URL.revokeObjectURL(this.captchaUrl);
          this.captchaUrl = "";
        }
        const res = await this.$https.getBlob("/api/captcha");
        const blob = res && (res.blob || res);
        const headers = (res && res.headers) || {};
        const contentType = headers["content-type"] || "image/png";
        const finalBlob =
          blob instanceof Blob ? blob : new Blob([blob], { type: contentType });
        this.captchaUrl = URL.createObjectURL(finalBlob);
        // 提取 captchaId（若存在）
        const lowerHeaders = {};
        Object.keys(headers).forEach(
          (k) => (lowerHeaders[k.toLowerCase()] = headers[k])
        );
        this.smsForm.captchaId = lowerHeaders["captcha-id"] || "";
        this.passwordForm.captchaId = lowerHeaders["captcha-id"] || "";
      } catch (error) {
        this.$Toast(error.message);
      } finally {
        this.codeLoading = false;
      }
    },
    startCountdown() {
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    async getSMSCode() {
      if (this.countdown > 0) {
        return;
      }

      if (!this.smsForm.phone) {
        this.$Toast("请输入手机号码");

        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.smsForm.phone)) {
        this.$Toast("请输入正确的手机号码");
        return;
      }
      // 校验图形验证码
      if (!this.smsForm.captcha) {
        this.$Toast("请输入图形验证码");
        return;
      }

      try {
        const res = await this.$https.post("/api/sms/sign-in", {
          phone: this.smsForm.phone,
          captchaId: this.smsForm.captchaId,
          captcha: this.smsForm.captcha.trim(),
        });
        this.startCountdown();
      } catch (error) {
        this.$Toast(error.message);
      }
    },

    handleCutType(val) {
      this.type = val;
    },
    commonLogin(res) {
      const data = res.data || res;
      sessionStorage.setItem("userInfo", JSON.stringify(data));
      //  localStorage，设置 30 天过期
      const expiresAt = Date.now() + 30 * 24 * 60 * 60 * 1000;
      localStorage.setItem("persistUser", JSON.stringify({ data, expiresAt }));
      this.$router.replace({ path: "/mobileHome" });
    },
    // 短信
    async handleSmsLogin() {
      if (this.loading) return;
      if (!this.smsForm.phone) {
        this.$Toast("请输入手机号码");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.smsForm.phone)) {
        this.$Toast("请输入正确的手机号码");
        return;
      }
      if (!this.smsForm.captcha) {
        this.$Toast("请输入图形验证码");
        return;
      }
      if (!this.smsForm.smsCode) {
        this.$Toast("请输入短信验证码");
        return;
      }
      this.loading = true;
      const params={
        ...this.smsForm,
        smsCode:this.smsForm.smsCode.trim(),
        captcha:this.smsForm.captcha.trim()
      }
      try {
        const res = await this.$https.post("/api/login-sms", params);
        if (res && (res.success || res.data)) {
          this.commonLogin(res);
        } else {
          this.$Toast(res && res.message ? res.message : "登录失败");
        }
      } catch (error) {
        // 刷新图形验证码
        this.getCaptchaCode();
        this.$Toast(error.message);
      } finally {
        this.loading = false;
      }
    },

    // 密码
    async handlePasswordLogin() {
      if (this.loading) return;

      if (!this.passwordForm.mobile) {
        this.$Toast("请输入手机号码");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.passwordForm.mobile)) {
        this.$Toast("请输入正确的手机号码");
        return;
      }
      if (!this.passwordForm.captcha) {
        this.$Toast("请输入验证码");
        return;
      }
      if (!this.passwordForm.password) {
        this.$Toast("请输入密码");
        return;
      }
      this.loading = true;
      const params={
        ...this.passwordForm,
        captcha:this.passwordForm.captcha.trim()
      }
      try {
        const res = await this.$https.post(
          "/api/login-captcha",
          params
        );
        if (res?.success || res?.data) {
          this.commonLogin(res);
        } else {
          this.$Toast(res && res.message ? res.message : "登录失败");
        }
      } catch (error) {
        // 刷新图形验证码
        this.getCaptchaCode();
        this.$Toast(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    // 初次进入时获取图形验证码
    this.getCaptchaCode();
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.captchaUrl) {
      URL.revokeObjectURL(this.captchaUrl);
      this.captchaUrl = "";
    }
  },
};
</script>
<style scoped lang="less">
.mobile—login {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 50px 40px;
  font-size: 20px;
  .header {
    text-align: center;
    margin-bottom: 100px;
  }
  .van-cell {
    line-height: 50px;
    padding: 0 10px;
    border: 1px solid #b0b9ca;
    border-radius: 5px;
    font-size: 16px;
  }
  .set {
    display: inline-block;
    top: 55px !important;
    line-height: 20px !important;
    cursor: pointer;
    right: 2px;
    color: #b0b9ca;
    font-size: 12px;
    border-bottom: 1px solid #b0b9ca;
  }
  .reset {
    display: inline-block;
    position: absolute;
    top: 0;
    line-height: 20px !important;
    cursor: pointer;
    right: 2px;
    color: #b0b9ca;
    font-size: 12px;
    border-bottom: 1px solid #b0b9ca;
  }
  .footer {
    margin-top: 50px;
    .login {
      line-height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .input-box-set {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .input-box {
    font-size: 20px;
    margin-top: 2%;
    position: relative;
    line-height: 40px;
    color: #677897;
    .sms-code {
      color: #088ed2;
      font-size: 18px;
    }
    .code-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .van-field {
        flex: 1;
        margin-right: 10px;
      }
      img {
        width: 200px;
        height: 44px;
      }
      .captcha-box{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .loading-img {
        width: 200px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .get-code {
        color: #088ed2;
        font-size: 18px;
        cursor: pointer;
        // width: 100px;
        padding: 5px 10px;
        border: 1px solid #088ed2;
        border-radius: 5px;
        transition: all 0.3s ease;
        white-space: nowrap;

        &.disabled {
          color: #ccc;
          border-color: #ccc;
          cursor: not-allowed;
          background-color: #f5f5f5;
        }
      }
    }
    .set-code {
      color: #088ed2;
      font-size: 18px;
      cursor: pointer;
    }
  }
}

// 小屏幕设备适配
@media screen and (max-width: 480px) {
  .mobile—login {
    padding: 30px 20px;
    font-size: 18px;
    .header {
      margin-bottom: 60px;
      img {
        max-height: 80px !important;
      }
    }
    .input-box {
      font-size: 18px;
      .sms-code {
        font-size: 16px;
      }
      .code-box {
        img {
          width: 140px;
          height: 40px;
        }
        .loading-img {
          width: 140px;
          height: 36px;
        }
        .get-code {
          font-size: 14px;
          padding: 4px 8px;
        }
      }
      .set-code {
        font-size: 16px;
      }
    }
    .footer {
      margin-top: 30px;
    }
  }
}

// 超小屏幕设备适配（如小手机）
@media screen and (max-width: 360px) {
  .mobile—login {
    padding: 20px 15px;
    font-size: 16px;
    .header {
      margin-bottom: 40px;
      img {
        max-height: 70px !important;
      }
    }
    .input-box {
      font-size: 16px;
      .sms-code {
        font-size: 14px;
      }
      .code-box {
        img {
          width: 120px;
          height: 36px;
        }
        .loading-img {
          width: 120px;
          height: 32px;
        }
        .get-code {
          font-size: 12px;
          padding: 3px 6px;
        }
      }
      .set-code {
        font-size: 14px;
      }
    }
    .footer {
      margin-top: 20px;
    }
  }
}
</style>
